const SvgComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 1201 305"
    className="min-h-52"
  >
    <linearGradient
      id="aa"
      x1={303.248}
      x2={303.248}
      y1={572.672}
      y2={571.672}
      gradientTransform="matrix(1200 0 0 -220 -363297 125987.75)"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#b5eaf6",
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: "#dbf6fb",
        }}
      />
    </linearGradient>
    <path
      d="M0 0h1200v220H0V0z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "url(#aa)",
      }}
    />
    <path
      d="M0 6.3C116 27 234.3 27 355 6.3 399-3 501.7-2 663 9.3c152.7 11.3 286 12.3 400 3 94-6 112-6 137-5v122H0V6.3z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
        fillOpacity: 0.3,
      }}
      transform="translate(0 175)"
    />
    <path
      d="M0 19.3c38.6-2.8 62.2-3.8 71-3 110 10 201.5 4.8 227-2 30-8 98.3-3.3 205 14l162-21c276 15.3 454.3 21.7 535 19 .7 0 .7 20.3 0 61H0v-68z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
        fillOpacity: 0.4,
      }}
      transform="translate(0 175)"
    />
    <path
      d="M0 33.3c66-14 190.7-14 374 0 59.3 5.3 103.3 3.7 132-5 134.7 8.7 241.7 6.7 321-6s158-12.7 236 0l137 11v96H0v-96z"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#fff",
      }}
      transform="translate(0 175)"
    />
  </svg>
)
export { SvgComponent as Errore }
